<template>
  <el-container>
    <el-header style="height: 110px">
      <!-- 顶部导航 -->
      <Menu :current="current" :title="userInfo?userInfo.userName:''+'大数据平台'" @change="tabChange"></Menu>
    </el-header>

    <el-main>
      <!-- 内容 -->
      <div class="layout-body">
       <Warm v-if="current == 0" :parkId="parkId"></Warm>
        <Water v-if="current == 1" :parkId="parkId"></Water>
        <FiveEmotions v-if="current == 2"></FiveEmotions>
        <Traceability v-if="current == 3"></Traceability>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Menu from "../../components/menu/menu.vue";
import Warm from "../content/warm/warm.vue";
import Water from "../content/water/water.vue";
import FiveEmotions from "../content/fiveEmotions/fiveEmotions.vue";
import Traceability from "../content/traceability/traceability.vue";
export default {
  name: "app",
  components: {
    // 菜单组件
    Menu,
    // 暖气组件
    Warm,
    // 水组件
    Water,
    // 五种情绪组件
    FiveEmotions,
    // 可追溯性组件
    Traceability,
  },
  data() {
    return {
      current: null,
      parkId:null,
      userInfo:{}
    };
  },
  created() {
    this.current = this.$route.query.current;
    // 获取当前页面的id
    this.parkId = this.$route.query.parkId;
    let userInfo=localStorage.getItem('user_info');
    this.userInfo=JSON.parse(userInfo);
    console.log("userInfo========",userInfo);
  },
  methods: {
    tabChange(e) {
      // 设置当前激活的tab
      this.current = e;
    },
  },
};
</script>

<style>
html{
  user-select: none;
}
	
.el-header {
  padding: 0px;
}

.el-main {
  padding: 0px;
  background-color: #010C2A;
}

.el-main::-webkit-scrollbar {
  display: none
}

.el-container.is-vertical {
  height: 100%;
  flex-direction: column;
}

.layout-body {
  padding: 5px 30px 15px 30px;
  background-color: #010C2A;
  height: 97%;
  color: #fff;
}
</style>
